module.exports = __webpack_public_path__ + "img/20.303586d9.png";